































































































































import { Vue, Component } from "vue-property-decorator";
import BankInfo from "../bank/BankInfo.vue";
import { profileStore } from "@/account/store";

@Component({
  components: {
    BankInfo
  }
})
export default class AccountPage extends Vue {
  preferences: any = {
    autoInvest: false
  };

  prerequisitesStep = 2;

  biometricIDAvailable: boolean = false;

  async mounted() {
    this.biometricIDAvailable = await this.authService.biometricsAvailable();
  }

  get profile() {
    return profileStore.state.profile;
  }

  get state() {
    return profileStore.state;
  }

  openFAQs() {
    window.open("http://remoteventures.com/faq", "_blank");
  }

  openTerms() {
    window.open("https://remoteventures.com/terms-and-conditions", "_blank");
  }

  openPortfolio() {
    this.$router.push("/portfolio");
  }

  step = 3;
  ticksLabels = ["Info", "Bank", "List", "Invest", "Legal"];
  list = [
    // {
    //   title: "Refer friends, earn money",
    //   icon: "account-multiple-plus",
    //   detail:
    //     "Sed in imperdiet ex. Vestibulum dignissim, augue vitae molestie ornare, ipsum quam dapibus quam, sodales ullamcorper felis turpis faucibus ipsum. Nulla mauris ex, semper in aliquam eget, lobortis eu lacus. Donec vitae lobortis dolor, at lobortis metus. Vestibulum tempus magna nec eros malesuada suscipit. Aliquam nisl nulla, pretium venenatis elementum in, malesuada a massa. Etiam dictum diam a nisl interdum, id sollicitudin lacus fringilla. Etiam quis eleifend tortor. Praesent sollicitudin iaculis nunc ut posuere. In hac habitasse platea dictumst. Mauris non odio ligula. Fusce semper libero gravida, accumsan libero sed, egestas orci."
    // },
    {
      title: "Get help",
      icon: "help-circle",
      action: this.openFAQs
    },
    {
      title: "Term of service",
      icon: "text",
      action: this.openTerms
    }
  ];
}
